module.exports = __webpack_public_path__ + "img/control-gzyc.3190c96b.svg";